/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useMemo, useState } from 'react';
import type { U3402InitLU } from './U3402Service';

export interface U3402ContextType {
  initLU: U3402InitLU;
  setInitLU: React.Dispatch<React.SetStateAction<U3402InitLU>>;
}

const U3402Context = createContext<U3402ContextType | undefined>(undefined);

interface U3402ContextProviderProps {
  initLU: U3402InitLU;
  children: React.ReactNode;
}

export const U3402ContextProvider: React.FC<U3402ContextProviderProps> = ({
  initLU,
  children,
}) => {
  const [initLUState, setInitLU] = useState(initLU);

  const value = useMemo(
    () => ({
      initLU: initLUState,
      setInitLU,
    }),
    [initLUState],
  );

  return <U3402Context.Provider value={value}>{children}</U3402Context.Provider>;
};

export function useU3402Context(): U3402ContextType {
  const ctx = useContext(U3402Context);
  if (!ctx) {
    throw new Error('useU3402Context must be used within U3402ContextProvider');
  }
  return ctx;
}
